<script lang="ts">
    let className: string = "";

    export { className as class };
</script>

<div class="rounded shadow {className}">
    <slot />
</div>